// extracted by mini-css-extract-plugin
export default {"description":"Description_description__Uxs7y","description__text":"Description_description__text__6CHB8"};